import React from 'react';
import PropTypes from 'prop-types';
import { OSMMap } from 'volto-venue';

const Body = ({ data, onChangeBlock }) => {
  return (
    <div>
      {__CLIENT__ && data?.latitude && data?.longitude ? (
        <>
          <OSMMap
            markers={[
              {
                latitude: data?.latitude || 0,
                longitude: data?.longitude || 0,
              },
            ]}
          />
        </>
      ) : null}
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Body.propTypes = {
  content: PropTypes.objectOf(PropTypes.any),
  pathname: PropTypes.string,
};

export default Body;
